import { UiGridItem } from './ui-grid-item';
import { I18nPath, NestedProperty } from '@madeinlune/drupal-types';
import { Expose } from 'class-transformer';

export class UiProjectGridItem extends UiGridItem {
  @NestedProperty('reference.path')
  @I18nPath()
  @Expose()
  override path: string | undefined;
}
